import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import configData from "../config.json";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Button,
} from "@mui/material";
import { fontSize } from "@mui/system";
//toast
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getToken } from "../utils/auth"

function SwanSong() {
  const params = useParams();
  const navigate = useNavigate();
  const [songResult, setSongResult] = useState(null);
  const notify = (message, style) => {
    if (style === "success") {
      toast.success(message, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.error(message, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  const getSwanSongResults = () => {
    const token = getToken()

    const headers = {
      "Content-Type": "application/json",
      "x-access-token": token,
    };

    fetch(
      `${configData.SERVER_URL}/Trigger/SwanSong/${params.device_id}`,
      { headers }
    )
      .then((res) => {
        if (!res.ok) {
          throw new Error(res.status);
        }
        return res.json();
      })
      .then((data) => {
        setSongResult(data);
      })
      .catch((error) => {
        if (error.message === "401") {
          navigate("/");
        } else {
          if (error.message === "403") {
            navigate(-1);
          } else {
            notify(error, "error");
          }
        }
      });
  };
  useEffect(() => {
    getSwanSongResults();
  }, []);
  return (
    <>
      {songResult ? (
        <div className="container-fluid">
          <h1>Results for: {params.device_id}</h1>
          <Button variant="contained" color="info" onClick={getSwanSongResults}>
            Reload
          </Button>
          {songResult.wifi.length !== 0 && (
            <h1>
              Networks result from:{" "}
              {new Date(songResult.wifi.timestamp).toLocaleString()}
            </h1>
          )}
          <div className="row">
            <div className="col-sm-12">
              <div className="row mb-3">
                <div className="col-md-6">
                  <div className="scroll-bg">
                    {songResult.images.length !== 0 ? (
                      <div className="scroll-div">
                        {songResult.images.map((item) => (
                          <div className="image-div">
                            <img
                              src={item.imageUrl}
                              alt="/"
                              className="scroll-object"
                            />
                            <span className="spn">
                              {new Date(item.timestamp).toLocaleString()}
                            </span>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <h4> No images found</h4>
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="scroll-bg">
                    <div className="scroll-div">
                      <TableContainer component={Paper}>
                        <Table aria-label="simple table">
                          <TableHead>
                            <TableRow>
                              <TableCell align="center">
                                <strong>Network Name</strong>
                              </TableCell>
                              <TableCell align="center">
                                <strong>Signal Strength</strong>
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          {songResult.wifi.length !== 0 && (
                            <TableBody>
                              {songResult.wifi.networks.map((row) => (
                                <TableRow
                                  sx={{
                                    "&:last-child td, &:last-child th": {
                                      border: 0,
                                    },
                                  }}
                                >
                                  <TableCell align="center">
                                    {row.name}
                                  </TableCell>
                                  <TableCell align="center">
                                    {row.level === "red" ? (
                                      <>
                                        {" "}
                                        <span
                                          className="material-symbols-outlined"
                                          style={{
                                            color: row.level,
                                          }}
                                        >
                                          signal_wifi_0_bar
                                        </span>{" "}
                                        <span>{row.power}</span>
                                      </>
                                    ) : row.level === "orange" ? (
                                      <>
                                        {" "}
                                        <span
                                          className="material-symbols-outlined"
                                          style={{ color: row.level }}
                                        >
                                          network_wifi_1_bar
                                        </span>
                                        <span>{row.power}</span>
                                      </>
                                    ) : row.level === "yellow" ? (
                                      <>
                                        {" "}
                                        <span
                                          className="material-symbols-outlined"
                                          style={{ color: row.level }}
                                        >
                                          network_wifi_2_bar
                                        </span>
                                        <span>{row.power}</span>
                                      </>
                                    ) : row.level === "lime" ? (
                                      <>
                                        {" "}
                                        <span
                                          className="material-symbols-outlined"
                                          style={{ color: row.level }}
                                        >
                                          network_wifi_3_bar
                                        </span>
                                        <span>{row.power}</span>
                                      </>
                                    ) : (
                                      <>
                                        {" "}
                                        <span
                                          className="material-symbols-outlined"
                                          style={{ color: row.level }}
                                        >
                                          signal_wifi_4_bar
                                        </span>
                                        <span>{row.power}</span>
                                      </>
                                    )}
                                  </TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          )}
                        </Table>
                      </TableContainer>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <CircularProgress size={72} />
      )}
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
}

export default SwanSong;
